import DatePicker from './src/date-picker.vue';

DatePicker.install = (app) => {
    app.component(DatePicker.name, DatePicker);
};

export default DatePicker;
declare module 'vue' {
    export interface GlobalComponents {
        PtDatePicker: typeof DatePicker;
    }
}
